/** Return a string as a "Title Case String" */
export const toTitleCase = (s: string) => {
    return s.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
}